import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ShoppingService } from '../../core/services/shopping.service';
import { CartItemsModel, ShoppingCartModel } from '../../core/models/ShoppingCart.model';
import { environment } from '../../../environments/environment';
import { HelperService } from '../../core/services/helper.service';
import { appApiResources, appVariables, appMessages } from '../../core/constants/Common.constant';
import { AddressModel, CountryModel, ErrorBody } from '../../core/models/ShoppingCart.model';
import { debug } from 'util';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Route, ActivatedRoute } from '@angular/router';
import { Response, Headers, RequestOptions, Http } from '@angular/http';
import { UserModel } from '../../core/models/ShoppingCart.model';

@Component({
  selector: 'app-physical-web-order',
  templateUrl: './physical-web-order.component.html',
  styleUrls: ['./physical-web-order.component.css']
})
export class PhysicalWebOrderComponent implements OnInit {

  BillingAddress: AddressModel;
  StateList: CountryModel[];
  StateList1: CountryModel[];
  ShowError: boolean;
  ShowOtherCountryError: boolean;
  IsPhysicalBookAdded = false;
  IncorrectAddressMsg: any;
  IncorrectAddressMsg3 = appMessages.IncorrectAddressMsg3;
  IncorrectAddressMsg4 = appMessages.IncorrectAddressMsg4;
  IncorrectAddressMsg5 = appMessages.IncorrectAddressMsg5;
  IncorrectAddressMsg6 = appMessages.IncorrectAddressMsg6;

  IsIncorrectAddressMsg3 = false;
  IsIncorrectAddressMsg4 = false;
  IsIncorrectAddressMsg5 = false;
  IsIncorrectAddressMsg6 = false;

  addressForm: FormGroup;
  CountryList: CountryModel[];
  ItemsCount = 0;
  IsDigitalBookAdded = false ;
  ErroMessage = [];
  Productids: any[] = [];
  AllProductids: string = '';
  fromLocal: UserModel;
  accountID: number;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<PhysicalWebOrderComponent>,
  private shoppingService: ShoppingService, 
  private router: Router,
  private helperService: HelperService, 
  private activatedRoute: ActivatedRoute, 
  private http: Http) {  }


  ngOnInit() {
    this.IsIncorrectAddressMsg3 = false;
    this.IsIncorrectAddressMsg4 = false;
    this.IsIncorrectAddressMsg5 = false;
    this.IsIncorrectAddressMsg6 = false;

    this.shoppingService.observeCartItems.subscribe(cartItemsList => {
      this.ItemsCount = cartItemsList.length;
      for (let i = 0; i < cartItemsList.length; i++) {
        if (cartItemsList[i].IsDigitalProduct !== true) {
          this.IsPhysicalBookAdded = true;
        }
        if(cartItemsList[i].IsDigitalProduct === true) {
          this.IsDigitalBookAdded = true;
        }
      }
    //  console.log(cartItemsList);
    });

    this.BillingAddress = new AddressModel(); 
    this.shoppingService.observeAddress.subscribe(address => {
      this.BillingAddress = address;
    //  this.StateList = this.BillingAddress.BillingCanadaStateList_ForAPI;
   //   this.CountryList = this.BillingAddress.BillingCountryList_ForAPI;
   //  console.log(this.BillingAddress);
    // const CountryValue = this.addressForm.controls['SelectedCountry'].value;
   //  string country = appVariables.CountryCode.Canada
    //Scenario 1-----------------

      //appVariables.CountryCode.Canada
    //------------------------------------------
  //   if (this.addressForm.controls.BillingShippingDifferent.value === false) {
  //  }

  // debugger;
  // console.log(this.data);
  // console.log(this.data.BillingCountryName);
  // console.log(this.data.ShippingCountryName);


  // this.BillingAddress.Country = this.BillingAddress.BillingCountryList_ForAPI
  //     .find(country => country.Value && this.addressForm.controls['SelectedCountry'] &&
  //       country.Value.toUpperCase() === this.addressForm.controls['SelectedCountry'].value.toUpperCase()).Text;
  //---------------------------------------------
  //if billing and shpping are same:--
  if(this.data.BillingShippingDifferent !== true){
    if((this.data.BillingCountryName === appVariables.CountryCode.Canada) && this.IsPhysicalBookAdded === true &&  this.IsDigitalBookAdded === false)
    {
       this.IncorrectAddressMsg = this.IncorrectAddressMsg3;
       this.IsIncorrectAddressMsg3 = true;
    }  
    else if((this.data.BillingCountryName !==  appVariables.CountryCode.Canada) && (this.data.BillingCountryName !==  appVariables.CountryCode.US)  && this.IsPhysicalBookAdded === true &&  this.IsDigitalBookAdded === false)
    {
       this.IncorrectAddressMsg = this.IncorrectAddressMsg4;
       this.IsIncorrectAddressMsg4 = true;
    }
    //Scenario 2
    else if( (this.data.BillingCountryName ===  appVariables.CountryCode.Canada ) && this.IsPhysicalBookAdded === true &&  this.IsDigitalBookAdded === true)
    {
       this.IncorrectAddressMsg = this.IncorrectAddressMsg5;
       this.IsIncorrectAddressMsg5 = true;
    }

    else if((this.data.BillingCountryName !==  appVariables.CountryCode.Canada ) && (this.data.BillingCountryName !== appVariables.CountryCode.US) && this.IsPhysicalBookAdded === true &&  this.IsDigitalBookAdded === true)
    {
       this.IncorrectAddressMsg = this.IncorrectAddressMsg6;
       this.IsIncorrectAddressMsg6 = true;
    }

  }
  else{
//Scenario 1-----------------
if((this.data.ShippingCountryName ===  appVariables.CountryCode.Canada) && this.IsPhysicalBookAdded === true &&  this.IsDigitalBookAdded === false)
{
   this.IncorrectAddressMsg = this.IncorrectAddressMsg3;
   this.IsIncorrectAddressMsg3 = true;
}

else if(( this.data.ShippingCountryName !==  appVariables.CountryCode.Canada) && (this.data.ShippingCountryName !== appVariables.CountryCode.US)  && this.IsPhysicalBookAdded === true &&  this.IsDigitalBookAdded === false)
{
   this.IncorrectAddressMsg = this.IncorrectAddressMsg4;
   this.IsIncorrectAddressMsg4 = true;
}
//Scenario 2
else if((this.data.ShippingCountryName ===  appVariables.CountryCode.Canada) && this.IsPhysicalBookAdded === true &&  this.IsDigitalBookAdded === true)
{
   this.IncorrectAddressMsg = this.IncorrectAddressMsg5;
   this.IsIncorrectAddressMsg5 = true;
}

else if((this.data.ShippingCountryName !== appVariables.CountryCode.Canada) && (this.data.ShippingCountryName !== appVariables.CountryCode.US)   && this.IsPhysicalBookAdded === true &&  this.IsDigitalBookAdded === true)
{
   this.IncorrectAddressMsg = this.IncorrectAddressMsg6;
   this.IsIncorrectAddressMsg6 = true;
}
}

    //------------------------------------------
   //  this.SetShowError(true);

     });

  }

  OnCloseClick() {
    this.dialogRef.close('');
  }
   
  RemoveItemsFromPurchase() {
      this.OnCloseClick();
  }

  // SetShowError(value) {
  //   this.ShowError = value;
  //   if (value === true && this.IsPhysicalBookAdded === false) {
  //     this.ShowError = false;
  //   }
  // }

  SetShowOtherCountryError(value) {
    this.ShowOtherCountryError = value;
    if (value === true && this.IsPhysicalBookAdded === false) {
      this.ShowOtherCountryError = false;
    }
  }
  
  OnRemoveClick() {
    this.clear();
    this.shoppingService.observeCartItems.subscribe(cartItemsList => {
      this.ItemsCount = cartItemsList.length;
      this.IsPhysicalBookAdded = false;
      for (let i = 0; i < cartItemsList.length; i++) {
        if (cartItemsList[i].IsDigitalProduct !== true) {
          this.IsPhysicalBookAdded = true;
          this.Productids.push(cartItemsList[i].ProductID); 
          this.Productids.toString();
          this.AllProductids = this.Productids.toString();
      //    console.log(this.AllProductids);
          
        }
      }  
      
      this.fromLocal = this.helperService.getUserFromLocalStorage();
      if(this.fromLocal['AccountID'] != null)
      {
        this.accountID = this.fromLocal['AccountID'];
      }
      else
      {
        this.accountID = 0;
      }
            if(this.IsPhysicalBookAdded === true) {
            this.shoppingService.RemovePhysicalProductsFromAPI(this.AllProductids,this.accountID)
            .subscribe(
              (response: Response) => {
              
                setTimeout(() => {
                  this.loadItems();
                });
              },
              (error) => {
                this.HandleError(error);
              
              }
            );
          }

    });
  }

  OnLoginCanadaClick(){
   // window.location.href = 'https://lb.ca/cgi-bin/cgiwrap/bookshelf?/Z109991';
    window.open('https://lb.ca/cgi-bin/cgiwrap/bookshelf?/Z109991', '_blank');
  }

  OnInternationalDistributorsClick()
  {
   // window.location.href = 'https://www.fadavis.com/international-distributors';
   window.open('https://www.fadavis.com/international-distributors', '_blank');
  }

  loadItems() {
    if (this.helperService.getFromLocalStorage(appVariables.displaySection) === 'LogOut') {
      this.helperService.setToLocalStorage(appVariables.displaySection, '');
    }

    this.shoppingService.GetCartItemsFromAPI(this.helperService.getFromLocalStorage(appVariables.promoCode),
      this.helperService.getFromLocalStorage(appVariables.cartGUID))
      .subscribe(
        (response) => {
          if (response.Data) {
            this.shoppingService.setCartItems(response.Data);
          }
        },
        (error) =>  {}
      );
      this.IsPhysicalBookAdded = false;
      this.RemoveItemsFromPurchase();
  }
  HandleError(error) {
    this.ErroMessage = [appMessages.CommonError]; // JSON.parse(error._body).Error;
  }
  clear() {
    this.ErroMessage = [];
  }

}



// WEBPACK FOOTER //
// ./src/app/shoppingcart/physical-web-order/physical-web-order.component.ts